// ============================================================
// Viewer / 主站 · OEM 应用（DW-P1-6）
// 品牌标题 / 页签图标（导航图标）/ 背景（登录与激活背景）
// 素材 URL 来自快照重写（./assets/oem/... → 运行基址），Web 链接/部署包/EXE 通用
// ============================================================

export interface ViewerOem {
  enabled?: boolean;
  title?: string;
  navIcon?: string | null;
  logo?: string | null;
  loginBg?: string | null;
}

export function applyViewerOem(raw: unknown): void {
  const oem = (raw ?? {}) as ViewerOem;
  if (!oem || typeof oem !== 'object') return;
  if (oem.enabled === false) return;
  if (typeof document === 'undefined') return;

  if (oem.title) document.title = String(oem.title);

  if (oem.navIcon) {
    let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = String(oem.navIcon);
  }

  if (oem.loginBg) {
    const url = `url(${String(oem.loginBg)})`;
    document.documentElement.style.setProperty('--viewer-oem-bg', url);
    document.documentElement.dataset.oemBg = '1';
    document.body.style.background = `${url} center/cover no-repeat, #0f0f1a`;
  }
}
